import React, { useState, useEffect, useRef } from 'react'; //ai useRef
import ItemSelector from './itemselector'; // Ensure the path is correct and in lowercase
import ExpandableSection from './expandablesection';
import Drawing from './drawing';
import './entrydoor.css'; // Import the CSS file for styles

import PanelTransom from './controls/transom/PanelTransom';
import PanelFrame from './controls/frame/PanelFrame';
import PanelSill from  './controls/sill/PanelSill';
import PanelBrickmould from './controls/brickmould/PanelBrickmould';
import PanelDoorpanel from './controls/doorpanel/PanelDoorpanel';
import PanelDoorLite from './controls/doorlite/PanelDoorLite';
import PanelSideLite from './controls/sidelite/PanelSideLite';


const EntryDoor = () => {
  const doorTypes = [
    { id: 1, name: 'Single Door',                   imageUrl: '/images/door-1.png' },
    { id: 2, name: 'Single Door - Left Side Lite',  imageUrl: '/images/door-2.png' },
    { id: 3, name: 'Single Door - Right Side Lite', imageUrl: '/images/door-3.png' },
    { id: 4, name: 'Single Door - Side Lites',      imageUrl: '/images/door-4.png' },
    { id: 5, name: 'Double Door',                   imageUrl: '/images/door-5.png' },
    { id: 6, name: 'Double Door - Left Side Lite',  imageUrl: '/images/door-6.png' },
    { id: 7, name: 'Double Door - Right Side Lite', imageUrl: '/images/door-7.png' },
    { id: 8, name: 'Double Door - Side Lites',      imageUrl: '/images/door-8.png' }
  ];
  const [passSelectedDoor, setPassSelectedDoor] = useState(""); //+++
  const [doorSizeValueT,   setDoorSizeValueT] = useState(""); //+++
  const [doorHeightValueT, setDoorHeightValueT] = useState(""); //+++
  const [selectedPanelT, setSelectedPanelT] = useState(""); //???

  const panelBrickmouldRef = useRef(null); // Ref for PanelBrickmould
  const panelFrameRef      = useRef(null); // Ref for PanelFrame
  const panelSillRef       = useRef(null); // Ref for PanelSill
  const panelTransomRef    = useRef(null); // Ref for PanelTransom
  const panelDoorpanelRef  = useRef(null); // Ref for panelDoorpanel
  const panelDoorLiteRef   = useRef(null);  // Ref for panelDoorLite
  const panelSideLiteRef   = useRef(null);  // Ref for panelSideLite


  const handleGetAllValues = () => {
    const allValues = {};
    //alert(JSON.stringify(frameData, null, 2));
    if (panelSideLiteRef.current) { // Get values from PanelDoorLite
      allValues.SideLite = panelSideLiteRef.current.getActiveControlsWithValues();
    }
    if (panelDoorLiteRef.current) { // Get values from PanelDoorLite
      allValues.DoorLite = panelDoorLiteRef.current.getActiveControlsWithValues();
      alert(JSON.stringify(allValues.DoorLite.DoorLiteSize, null, 2));
    }
    if (panelDoorpanelRef.current) { // Get values from PanelDoorpanel
      allValues.Doorpanel = panelDoorpanelRef.current.getActiveControlsWithValues();
    }
    if (panelBrickmouldRef.current) { // Get values from PanelBrickmould
      allValues.Brickmould = panelBrickmouldRef.current.getActiveControlsWithValues();
    }
    if (panelFrameRef.current) { // Get values from PanelFrame
      allValues.Frame = panelFrameRef.current.getActiveControlsWithValues();
    }
    if (panelSillRef.current) { // Get values from PanelSill
      allValues.Sill = panelSillRef.current.getActiveControlsWithValues();
    }
    if (panelTransomRef.current) { // Get values from PanelSill
      allValues.Transom = panelTransomRef.current.getActiveControlsWithValues();
    }
    alert(JSON.stringify(allValues, null, 2));
    return allValues;
  }
  //---set functions....
  // State to capture panel DoorLite-related values
  const [sideLiteData, setPanelSideLiteData] = useState({
 
  });
  const handlePanelSideLiteChange = React.useCallback((data) => {
        setPanelSideLiteData(data);
  }, []); 

      // State to capture panel DoorLite-related values
  const [doorLiteData, setDoorLiteData] = useState({
        selectedDoorLite: "",
  });
  const handleDoorLiteChange = React.useCallback((data) => {
        setDoorLiteData(data);
  }, []); // Stable reference with no unnecessary re-creations

      // State to capture panel Doorpanel-related values
  const [doorPanelData, setPanelDoorpanelData] = useState({
        selectedPanel: "",
        selectedPanelValue: "",
  });
  const handlePanelDoorpanelChange = React.useCallback((data) => {
    console.log("handlePanelDoorpanelChange received:", data);
        setPanelDoorpanelData(data);
  }, []); // Empty dependency array ensures the reference is stable

      // State to capture panel Brickmould-related values
  const [brickmouldData, setPanelBrickmouldData] = useState({
 
  });
  const handlePanelBrickmouldChange = React.useCallback((data) => {
        setPanelBrickmouldData(data);
  }, []); // Empty dependency array ensures a stable reference

      // State to capture panel Sill-related values
  const [sillData, setPanelSillData] = useState({

  });
  const handlePanelSillChange = React.useCallback((data) => {
        setPanelSillData(data);
  }, []); // No dependencies, as this state setter is stable

     // State to capture panel Frame-related values
  const [frameData, setPanelFrameData] = useState({
      quantity: "",
      doorSize: "",
      doorHeight: "",
      frameWidth: "",
      frameHeight: "",
      jambs: "",
      hinges: "",
      swing: "",
  });
  const handlePanelFrameChange = React.useCallback((data) => {
    console.log("handlePanelFrameChange received:", data);
    //alert(JSON.stringify(data, null, 2));
/*    setPanelFrameData((prevData) => ({
      ...prevData, // Keep existing frameData values
      ...data,     // Merge new values from PanelFrame
    }));*/
    setPanelFrameData(data);
    //setDoorSizeValueT(data.doorSize);
    //setDoorHeightValueT(data.doorHeight);
  }, []); // No dependencies, as these state setters are stable

   // State to capture panel Transom-related values
   const [transomData, setPanelTransomData] = useState({
    transom: "",
    overallHeight: "",
    transomLite: "",
    transomCasing: "",
    transomOnLoose: "",
  });
  const handlePanelTransomChange = React.useCallback((data) => {
    setPanelTransomData(data);
  }, []); // Empty dependency array ensures stable reference

  const [frameColorValue, setFrameColorValue] = useState("");
  //const [frameWidthValue, setFrameWidthValue] = useState(""); //--
  //const [frameHeightValue, setFrameHeightValue] = useState(""); //--
  const [sideLiteSizeValue, setSideLiteSizeValue] = useState("");
  //  const [transomValue, setTransomValue] = useState("");
  //  const [overallHeightValue, setOverallHeightValue] = useState("");
  //  const [transomLiteValue, setTransomLiteValue] = useState("");
  const [swingValue, setSwingValue] = useState("");
  const [hingesValue, setHingesValue] = useState("");
  const [hingesCoverColorValue, setHingesCoverColorValue] = useState("");
  const [glassDividersValue, setGlassDividersValue] = useState("");
  const [glassDividersVerticalValue, setGlassDividersVerticalValue] = useState("");
  const [glassDividersHorizontalValue, setGlassDividersHorizontalValue] = useState("");
  const [exteriorFinishValue, setExteriorFinishValue] = useState("");
  const [interiorFinishValue, setInteriorFinishValue] = useState("");


  const controlMap = []

  const itemSelectorRef = useRef(null); //ai
  
  const [selectedDoor, setSelectedDoor] = useState(null);

  useEffect(() => {
    console.log("frameData updated:", frameData);
  }, [frameData]);

  useEffect(() => {  
    if (doorPanelData) {
      //alert(JSON.stringify(doorPanelData, null, 2)); // Trigger alert on change
    }
    if (doorLiteData) {
      //alert(JSON.stringify(doorLiteData, null, 2)); // Trigger alert on change
    }
  }, [doorPanelData, doorLiteData]);

  const frameDataCopy = { ...frameData }; // Creating a shallow copy of frameData
  const doorLiteDataCopy = {...doorLiteData};//Creating a shallow copy of doorLiteData
  frameDataCopy.doorLiteData = doorLiteDataCopy; // Adding doorLiteDataCopy as a property
  return (
<div className='entire-container'>
    <div className="door-container">
      <ExpandableSection title1="Select Door Type" state="true">
      <ItemSelector ref={itemSelectorRef} items={doorTypes} selectedDoor={selectedDoor} onSelect={setSelectedDoor} />
      </ExpandableSection>
      {selectedDoor && (
        <div className1="door-container">
          <div className1="configurations">

            <div className="door"><p>{selectedDoor.name}</p></div>

          </div>
          <PanelFrame ref={panelFrameRef}
            /*onChange={(data) => {
            setPanelFrameData(data); // This updates the state in EntryDoor
            setDoorSizeValueT(data.doorSize);     // Capture DoorSize value for use in PanelTransom + 
            setDoorHeightValueT(data.doorHeight); // Capture DoorHeight value for use in PanelTransom + 
            }}*/
            onChange={handlePanelFrameChange} // Use the stable function 
            passSelectedDoor={selectedDoor} // Pass function to pass door type +
            //doorSizeValueTriggered={doorSizeValueT} // Pass DoorSize value + 
            //doorHeightValueTriggered={doorHeightValueT} // Pass DoorHeight value + 
            //setDoorSizeValueT={setDoorSizeValueT} // Pass function to update DoorSize + 
            //setDoorHeightValueT={setDoorHeightValueT} // Pass function to update DoorHeight + 
          />
        

          <PanelTransom ref={panelTransomRef}
            /*onChange={(data) => {
            setPanelTransomData(data); // This updates the state in EntryDoor
            }}*/
            onChange={handlePanelTransomChange} // Pass the stable function 
            doorSizeValueTriggered={frameData.doorSize} //{doorSizeValueT} // Pass DoorSize value to PanelTransom
            doorHeightValueTriggered={frameData.doorHeight}//{doorHeightValueT} // Pass DoorHeight value to PanelTransom
            passSelectedDoor={selectedDoor} // Pass function to pass door type +
          />


          <PanelSill ref={panelSillRef}
           /*onChange={(data) => {
              setPanelSillData(data); // This updates the state in EntryDoor
            }}*/ 
            onChange={handlePanelSillChange} // Pass the stable function
          />


          <PanelBrickmould ref={panelBrickmouldRef} // Pass the ref to PanelBrickmould 
            /*onChange={(data) => {
                setPanelBrickmouldData(data); // This updates the state in EntryDoor
            }}*/
            onChange={handlePanelBrickmouldChange} // Pass the stable function
          />
          <button onClick={handleGetAllValues}>Get All Panel Values</button>


          <PanelDoorpanel ref={panelDoorpanelRef} // Pass the ref to PanelDoorpanel
            /*onChange={(data) => {
              setPanelDoorpanelData(data); // This updates the state in EntryDoor
            }}*/
            onChange={handlePanelDoorpanelChange} // Pass the stable function
            doorSizeValueTriggered={frameData.doorSize} //{doorSizeValueT} // Pass DoorSize value to PanelTransom
            doorHeightValueTriggered={frameData.doorHeight} //{doorHeightValueT} // Pass DoorHeight value to PanelTransom
            passSelectedDoor={selectedDoor} // Pass function to pass door type + 
          />
         
          {doorPanelData.selectedPanel && doorPanelData.selectedPanel.doorlite === "1" ? ( 
          <PanelDoorLite ref={panelDoorLiteRef} // Pass the ref to PanelDoorLite
            state="true"
            /*onChange={(data) => {
              setDoorLiteData(data); // This updates the state in EntryDoor
            }}*/
            onChange={handleDoorLiteChange} // Pass memoized function
            selectedPanel={doorPanelData.selectedPanel} // how to pass inside component?
          />
          ) : null} {/* Render nothing if no door panel is selected */}

          <PanelSideLite ref={panelSideLiteRef} // Pass the ref to PanelSideLite 
            /*onChange={(data) => {
            setPanelSideLiteData(data); // This updates the state in EntryDoor
            }}*/
            onChange={handlePanelSideLiteChange}  
          />


          <ExpandableSection
              title="Finish Section"
              panelLocation="4"
              controlMap={controlMap.filter((control) => control.expandableSectionId === "Finish")}
          />
          <ExpandableSection
              title="Test"
              panelLocation="12"
              controlMap={controlMap.filter((control) => control.expandableSectionId === "Test1")}
          />
          <ExpandableSection title="Additional Items" className="expandable-section" ></ExpandableSection>
          <ExpandableSection
              title="Notes"
              panelLocation="3"
              controlMap={controlMap.filter((control) => control.expandableSectionId === "Notes")}
          />
        </div>
      )}
    </div>
    <div className="door-container shift-down image-container"  >
    {selectedDoor ? 
              <div className="fixed-container">
      {console.log("Passing data to Drawing.js:", {
            doorLiteData,
            selectedDoor,
            frameColor: frameColorValue,
            frameWidth: frameDataCopy.frameWidth,
            frameHeight: frameDataCopy.frameHeight,
            doorSize: frameDataCopy.doorSize,
            doorHeight: frameDataCopy.doorHeight,
            frameData,
            sideLiteSize: sideLiteSizeValue,
            hinges: frameDataCopy.hinges,
            transom: {
                transom: { value: transomData.transom },
                overallHeight: { value: transomData.overallHeight }
            },
            swing: frameDataCopy.swing,
            doorLite: {
                glassDividers: { value: glassDividersValue },
                glassDividersVertical: { value: glassDividersVerticalValue },
                glassDividersHorizontal: { value: glassDividersHorizontalValue },
                exteriorFinish: { value: exteriorFinishValue },
                interiorFinish: { value: interiorFinishValue }
            },
            selectedPanel: doorPanelData.selectedPanel,
            selectedDoorLite: doorLiteData.selectedDoorLite
        })}
              {/* <Drawing
              selectedDoor={selectedDoor}
              frameColor={frameColorValue}
              frameWidth={frameDataCopy.frameWidth}
              frameHeight={frameDataCopy.frameHeight}
              doorSize={frameDataCopy.doorSize}
              doorHeight={frameDataCopy.doorHeight}
              frameData={frameDataCopy}
              sideLiteSize={sideLiteSizeValue}
              hinges={frameDataCopy.hinges}
              transom={{
                   transom: {value: transomData.transom},
                   overallHeight: {value: transomData.overallHeight}
              }}
              swing={frameDataCopy.swing}
              doorLite={{
                  glassDividers: { value: glassDividersValue },
                  glassDividersVertical: { value: glassDividersVerticalValue },
                  glassDividersHorizontal: { value: glassDividersHorizontalValue },
                  exteriorFinish: { value: exteriorFinishValue },
                  interiorFinish: { value: interiorFinishValue }
                }
              }
              selectedPanel={doorPanelData.selectedPanel}
              selectedDoorLite={doorLiteData.selectedDoorLite}
    /> */}</div> : 'select sizes to create an image'}
    </div>
  </div>
  );
};

export default EntryDoor;
